import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Details from "./Details";
import PricingDetails from "./PricingDetails";
import QuotationDetail from "./QuotationDetail";

type Props = {
  onNext: VoidFunction | null;
  onPrevious: VoidFunction | null;
};

const LiabilityFormRoutes: FC<Props> = props => (
  <Routes>
    <Route path="details" element={<Details {...props} />} />
    <Route path="pricing" element={<PricingDetails {...props} />} />
    <Route path="quoteDetails" element={<QuotationDetail />} />
    <Route path="" element={<Navigate to="details" />} />
  </Routes>
);

export default LiabilityFormRoutes;
